import * as gfunctions from '../../../js/generalFunctions';
/* eslint-disable */

CCL.airportAddToCart = {
  autoload: [
    ['initialLoad', $('.airport-add-to-cart').length > 0],
    ['closeSuccessModal', $('.airport-add-to-cart').length > 0]
  ],

  firstAddToCartResponse: {},
  productCode: '',
  initialLoad() {
    console.log('Inside initialLoad');
    $('.airport-add-to-cart').click((e) => {
      this.productCode = $(e.currentTarget).data('productcode');
      console.log('conflict modal code');
      this.loadJsonData(e);
    });
  },

  closeModal() {
    $('.close').click((e) => {
      gfunctions.hideModal('transfersConflictModal');
    });
  },

  closeSuccessModal() {
    $('body').on('click', '#addToCartSuccessModal .close', (e) => {
      console.log('Success modal close button clicked')
      this.showConflictMessages(this.productCode);
    });
  },

  async showConflictMessages(ajaxObj) {
    gfunctions.showLoader();
    const token = $('#csrfSessionToken').data('csrf');
    let ajaxUrl = '';
    let method = 'POST';
    const dataObject = {
      productCode: ajaxObj.toString()
    };
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/airport-close-modal/airport-close-modal.json';
      method = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
    }
    try {
      const inputDataObj = {
        url: ajaxUrl,
        type: method,
        contentType: 'application/json',
        headers: {
          CSRFToken: token
        },
        data: JSON.stringify(dataObject)
      };
      const res = await gfunctions.doAjax(inputDataObj);
      gfunctions.hideLoader();
      console.log(res);
      if (res.globalErrorMessage) {
        $('.inner-wrap.trip-options').find('.global-error-message').text(res.globalErrorMessage);
        $('.inner-wrap.trip-options').find('.global-error-message').removeClass('d-none');
        $('.inner-wrap.trip-options').find('.departure-error-message').addClass('d-none');
        $('.inner-wrap.trip-options').find('.arrival-error-message').addClass('d-none');
        this.disableSelectable('Departures');
        this.disableSelectable('Arrivals');
      } else if (res.departureConflictErrorMessage) {
        $('.inner-wrap.trip-options').find('.departure-error-message').text(res.departureConflictErrorMessage);
        $('.inner-wrap.trip-options').find('.departure-error-message').removeClass('d-none');
        this.disableSelectable('Departures');
      } else if (res.arrivalConflictErrorMessage) {
        $('.inner-wrap.trip-options').find('.arrival-error-message').text(res.arrivalConflictErrorMessage);
        $('.inner-wrap.trip-options').find('.arrival-error-message').removeClass('d-none');
        this.disableSelectable('Arrivals');
      }
    } catch (err) {
      gfunctions.hideLoader();
      const cartAPIError = { customError: err };
      console.log(cartAPIError);
    }
  },

  disableSelectable(name) {
    const group = $('.inner-wrap.trip-options').find(`a[data-name=${name}]`);
    group.removeClass('selected');
    group.addClass('div-link');
    $('.airport-add-to-cart').attr('disabled', 'disabled');
  },

  loadJsonData(event) {
    gfunctions.showLoader();
    const csrf = $(event.target).data('csrf') ? $(event.target).data('csrf') : $('#csrfSessionToken').data('csrf');
    const targetElement = $(event.target).data('hasvariants');
    const quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input') && $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
    const variantId = $(event.target).attr('data-variantids');
    const isSpecialService = $(event.target).attr('data-specialService');
    const bookingIdsArray = $(event.target).attr('data-bookingIds') ? $(event.target).attr('data-bookingIds').split(',') : '';
    const guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : '';
    const dataObj = {
      productCodePost: $(event.target).data('productcode'),
      CSRFToken: csrf,
      qty: quantity || 1,
      variantIds: variantId,
      bookingIds: bookingIdsArray,
      guestIds: guestIdsArray,
      specialService: isSpecialService
    };

    $.ajax({
      type: 'POST',
      url: '/shop/cart/add',
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      data: dataObj,
      headers: {
        CSRFToken: csrf
      }
    }).done((response) => {
      gfunctions.hideLoader();
      if (!response.isProductAdded) {
        this.firstAddToCartResponse = response;
        this.loadHtmlData(response);
      } else {
        gfunctions.hideModal('transfersConflictModal');
        CCL.addToCart.successModal(response);
        gfunctions.updateHeaderCartWidget(response);
      }
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while fetching data');
    });
  },

  conflictAddToCart() {
    console.log('Inside conflictResponse');
    $('.transfer-conflict-add-to-cart').click((event) => {
      gfunctions.showLoader();
      const csrf = $(event.target).data('csrf') ? $(event.target).data('csrf') : $('#csrfSessionToken').data('csrf');
      const guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : '';
      const prodId = $(event.target).attr('data-productid') ? $(event.target).attr('data-productid') : '';
      const preSaleId = $(event.target).attr('data-presaleid') ? $(event.target).attr('data-presaleid') : '';
      const conflictPreSaleId = $(event.target).attr('data-conflictingpresalesid') ? $(event.target).attr('data-conflictingpresalesid') : '';
      const dataObj = {
        productCodePost: $(event.target).data('productcode'),
        CSRFToken: csrf,
        guestsId: guestIdsArray,
        productId: prodId,
        preSalesId: preSaleId,
        conflictingPreSaleId: conflictPreSaleId
      };

      $.ajax({
        type: 'POST',
        url: '/shop/cart/transfer/addTransfersGuests',
        contentType: 'application/json',
        data: JSON.stringify(dataObj),
        headers: {
          CSRFToken: csrf
        }
      }).done((res) => {
        gfunctions.hideLoader();
        if (res.productAdded && !res.showDepartureConflict) {
          gfunctions.hideModal('transfersConflictModal');
          CCL.addToCart.successModal(res);
        } else {
          this.loadHtmlData(res.conflictResponse);
        }
      }).fail(() => {
        gfunctions.hideLoader();
        console.log('error while fetching data');
      });
    });
  },

  loadHtmlData(jsonData) {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/transfers-conflict/transfers-conflict.html'
    }).done((response) => {
      gfunctions.hideLoader();
      const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
      const jsonArrivalData = jsonData.timeSlotsCard.filter(x => (x.transferInformation.transferType.toLowerCase() === 'arrival' && (x.isConflictingTimeSlot || x.conflictingTimeSlot)));
      const jsonDepartureData = jsonData.timeSlotsCard.filter(x => (x.transferInformation.transferType.toLowerCase() === 'departure' && (x.isConflictingTimeSlot || x.conflictingTimeSlot)));
      const arrivalPresalesId = jsonArrivalData.length ? jsonArrivalData[0].transferInformation.preSaleId : '';
      const departurePresalesId = jsonDepartureData.length ? jsonDepartureData[0].transferInformation.preSaleId : '';
      let preSalesId;
      let conflictingPresalesId;
      if (jsonArrivalData.length > 0 && jsonDepartureData.length > 0) {
        jsonData.timeSlotsCard = jsonArrivalData;
        jsonArrivalData[0].transferInformation.date = new Date(jsonArrivalData[0].transferInformation.date).toLocaleDateString('en-US', options);
        preSalesId = jsonArrivalData[0].transferInformation.preSaleId;
        const html = gfunctions.createDynamicHTML(response, jsonData);
        conflictingPresalesId = jsonDepartureData[0].transferInformation.preSaleId;
        $('#transfersConflictModalContent').empty().append(html);
      } else if (jsonArrivalData.length > 0) {
        jsonData.timeSlotsCard = jsonArrivalData;
        preSalesId = jsonArrivalData[0].transferInformation.preSaleId;
        jsonArrivalData[0].transferInformation.date = new Date(jsonArrivalData[0].transferInformation.date).toLocaleDateString('en-US', options);
        const html = gfunctions.createDynamicHTML(response, jsonData);
        $('#transfersConflictModalContent').empty().append(html);
      } else if (jsonDepartureData.length > 0) {
        jsonData.timeSlotsCard = jsonDepartureData;
        preSalesId = jsonDepartureData[0].transferInformation.preSaleId;
        jsonDepartureData[0].transferInformation.date = new Date(jsonDepartureData[0].transferInformation.date).toLocaleDateString('en-US', options);
        const html = gfunctions.createDynamicHTML(response, jsonData);
        $('#transfersConflictModalContent').empty().append(html);
      }
      gfunctions.showModal('transfersConflictModal');
      gfunctions.pdpGetSelectedData();
      gfunctions.checkboxCheck();
      this.initialLoad();
      $('.transfer-conflict-add-to-cart').attr('data-presaleid', preSalesId);
      $('.transfer-conflict-add-to-cart').attr('data-conflictingpresalesid', conflictingPresalesId);
      this.closeModal();
      this.conflictAddToCart();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while loading html');
    });
  }

};



// WEBPACK FOOTER //
// ./src/app/components/c-transfers-conflict-modal/transfers-conflict-modal.js